var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDolby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,150v700h980V150H10z M237.3,759.3H125.6V240.6h111.7c115.9,0,212.9,118.5,212.9,258.3C450.2,643,353.3,759.3,237.3,759.3z M874.6,759.3h-112c-116.1,0-212.8-116.3-212.8-260.4c0-139.8,96.7-258.3,212.8-258.3h112V759.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolby);
export default __webpack_public_path__ + "static/media/Dolby.411282d5b9200a9d959ff46af2d88f4b.svg";
export { ForwardRef as ReactComponent };